"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntervalFormulas = void 0;
class IntervalFormulas {
    static getFormulas({ dspNumbersBilled }) {
        if (dspNumbersBilled) {
            return this.getEmxNumbersBilled();
        }
        return this.getDspNumbersBilled();
    }
    static getDspNumbersBilled() {
        return {
            getImpsDisc: (imps, impsAdj) => Number(((1 - Number(imps / impsAdj)) * 100).toFixed(2)),
            getImpsAdj: (imps, impsDisc) => Number((imps / (1 - (impsDisc / 100))).toFixed(0)),
            getRevDisc: (rev, revAdj) => Number(((1 - Number(rev / revAdj)) * 100).toFixed(2)),
            getRevAdj: (rev, revDisc) => Number((rev / (1 - (revDisc / 100))).toFixed(2)),
            getCpmDisc: (cpm, cpmAdj) => Number(((1 - Number(cpm / cpmAdj)) * 100).toFixed(2)),
        };
    }
    static getEmxNumbersBilled() {
        return {
            getImpsDisc: (imps, impsAdj) => Number(((1 - Number(impsAdj / imps)) * 100).toFixed(2)),
            getImpsAdj: (imps, impsDisc) => Number((1 - (impsDisc / 100)) * imps).toFixed(0),
            getRevDisc: (rev, revAdj) => Number(((1 - Number(revAdj / rev)) * 100).toFixed(2)),
            getRevAdj: (rev, revDisc) => Number((1 - (revDisc / 100)) * rev).toFixed(2),
            getCpmDisc: (cpm, cpmAdj) => Number(((1 - Number(cpmAdj / cpm)) * 100).toFixed(2)),
        };
    }
}
exports.IntervalFormulas = IntervalFormulas;
//# sourceMappingURL=intervalFormulas.js.map